export function pageURL(current, next, section) {
  const base = new URL(current);
  const target = new URL(next, base);
  if (target.origin !== base.origin) throw new Error('Pagination must stay on this store.');
  for (const [key,value] of target.searchParams) base.searchParams.set(key,value);
  base.searchParams.set('section_id',section);
  base.hash = '';
  return base.href;
}
export function appendKeys(existing, incoming) {
  const seen = new Set(existing);
  return incoming.filter(key => { if(seen.has(key)) return false; seen.add(key); return true; });
}

if (typeof document !== 'undefined') {
  if (!customElements.get('z-verified-gallery')) customElements.define('z-verified-gallery', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events=new AbortController();
      const options={signal:this.events.signal};
      this.track=this.querySelector('.z-gallery__track');
      this.slides=[...this.querySelectorAll('[data-z-zoom]')];
      this.index=0;
      this.dialog=this.querySelector('dialog');
      this.addEventListener('click',event=>{
        const button=event.target.closest('button');
        if(!button)return;
        if(button.hasAttribute('data-z-step'))this.go(this.index+Number(button.dataset.zStep));
        if(button.hasAttribute('data-z-index'))this.go(Number(button.dataset.zIndex));
        if(button.hasAttribute('data-z-zoom')) {
          this.opener=button;
          const source=button.querySelector('img');
          const full=new URL(source.src);full.searchParams.set('width','2000');
          this.dialog.querySelector('img').src=full.href;
          this.dialog.querySelector('img').alt=source.alt;
          this.dialog.showModal();
        }
        if(button.hasAttribute('data-z-close'))this.dialog.close();
      },options);
      this.addEventListener('keydown',event=>{
        if(this.dialog.open)return;
        if(event.key==='ArrowRight'||event.key==='ArrowLeft') {
          event.preventDefault();this.go(this.index+(event.key==='ArrowRight'?1:-1));
        }
      },options);
      this.dialog.addEventListener('close',()=>this.opener?.focus({preventScroll:true}),options);
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog)this.dialog.close();},options);
      this.track.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.frame);
        this.frame=requestAnimationFrame(()=>this.sync());
      },{...options,passive:true});
      this.sync();
    }
    disconnectedCallback(){this.events?.abort();cancelAnimationFrame(this.frame);}
    go(index){
      index=Math.max(0,Math.min(this.slides.length-1,index));
      this.track.scrollTo({left:this.slides[index].offsetLeft-this.slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    sync(){
      const start=this.track.getBoundingClientRect().left;
      this.index=this.slides.reduce((best,slide,i)=>Math.abs(slide.getBoundingClientRect().left-start)<Math.abs(this.slides[best].getBoundingClientRect().left-start)?i:best,0);
      const count=this.querySelector('[data-z-gallery-count]');if(count)count.textContent=`${this.index+1} / ${this.slides.length}`;
      this.querySelectorAll('[data-z-index]').forEach((button,i)=>button.setAttribute('aria-current',String(i===this.index)));
      this.querySelectorAll('[data-z-step]').forEach(button=>button.disabled=Number(button.dataset.zStep)<0?this.index===0:this.index===this.slides.length-1);
    }
  });
  const sectionOf = el => el.closest('.shopify-section');
  const keyOf = el => {
    const card = el.querySelector('[data-z-product-id]');
    if(card) return card.dataset.zCardKey || card.dataset.zProductId + ':' + (card.dataset.zProductColour || '');
    return el.querySelector('a[href]')?.getAttribute('href') || el.getAttribute('href') || el.id;
  };
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-z-next]');
    if(!link || event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
    const footer = link.closest('[data-z-load-more]');
    const section = sectionOf(footer);
    const grid = section?.querySelector(footer.dataset.target);
    if(!grid) return;
    event.preventDefault();
    if(footer.dataset.busy) return;
    footer.dataset.busy='true';
    footer.querySelector('[data-z-load-error]').hidden=true;
    link.setAttribute('aria-disabled','true');
    link.textContent='LOADING';
    grid.setAttribute('aria-busy','true');
    const originalURL=location.href;
    const controller = new AbortController();
    const timeout=setTimeout(()=>controller.abort(),20000);
    try {
      const response = await fetch(pageURL(originalURL,link.href,footer.dataset.section), {signal:controller.signal});
      if(!response.ok) throw Error('Page unavailable');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      if(!footer.isConnected || location.href!==originalURL) return;
      const nextGrid=html.querySelector(footer.dataset.target);
      const nextFooter=html.querySelector('[data-z-load-more]');
      if(!nextGrid||!nextFooter) throw Error('Incomplete page');
      const seen=new Set([...grid.children].map(keyOf));
      const fragment=document.createDocumentFragment();
      const appended=[];
      for(const child of [...nextGrid.children]) {
        const key=keyOf(child);
        if(!key||!seen.has(key)){seen.add(key);fragment.append(child);appended.push(child);}
      }
      if(appended.length) document.dispatchEvent(new CustomEvent('zico:products-appending',{detail:{sectionId:footer.dataset.section,scope:grid,items:appended}}));
      grid.append(fragment);
      const start=Number(footer.dataset.start ?? footer.dataset.offset);
      nextFooter.dataset.start=String(start);
      const ids=[...grid.querySelectorAll('[data-z-product-id]')].map(el=>el.dataset.zProductId);
      const count=ids.length ? new Set(ids).size : grid.children.length;
      const total=Number(nextFooter.dataset.total);
      const viewed=Math.min(start+count,total);
      nextFooter.querySelector('[data-z-count]').textContent=`Viewing ${start+1} - ${viewed} of ${total} ${nextFooter.dataset.label}`;
      nextFooter.querySelector('progress').value=viewed;
      footer.replaceWith(nextFooter);
      const pages=history.state?.zicoPages||[];
      if(!pages.includes(link.href))history.replaceState({...history.state,zicoPages:[...pages,link.href]},'');
      (nextFooter.querySelector('[data-z-next]')||nextFooter.querySelector('[data-z-count]')).focus({preventScroll:true});
      document.dispatchEvent(new CustomEvent('zico:products-appended',{detail:{sectionId:footer.dataset.section,scope:grid,items:appended}}));
    } catch(error) {
      if(footer.isConnected) footer.querySelector('[data-z-load-error]').hidden=false;
    } finally {
      clearTimeout(timeout);
      grid.removeAttribute('aria-busy');
      delete footer.dataset.busy;
      link.removeAttribute('aria-disabled');
      link.textContent='LOAD MORE';
    }
  });

}

